angular.module("registrace")

.controller('RegistraceDokonceniCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function($scope, $http, $location, api, Registrace, Container) {

	$scope.deaktivateApp = deaktivateApp;

	if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
		api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
		return;
	}

	$scope.$on('ResponseMessagesReceived', function(event, messages) {
		Container.setMessages(messages);
		$scope.messages = messages;
	});


	$scope.messages = [];
	$scope.formDataSms = {};
	$scope.formData = {};
	$scope.blured = {};
	$scope.loading = false;

	$scope.step1response = {};

	$scope.data = {
		customized: false
	};

	$scope.state = {
		sent: false,
		sending: false
	};

    $scope.emailRegex = new RegExp("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$");

	$scope.init = function() {
		api.logAnonymousAppAction('REGISTRACE', 'VIEW', 'STEP', 'Druhý krok');
		$scope.step1response.isCompany = Container.isCompany();
		$scope.data.customized = Container.getCustomized();
        Registrace.getEmailRegex().success(function(response) {
            $scope.emailRegex = new RegExp(response.data);
        }).error(function(response) {

        });

		if (Container.getMessages().length > 0) {
			$scope.step1response.messages = Container.getMessages();
		}
	};

	$scope.init();

	$scope.setBlured = function(elem, blured) {
		$scope.blured[elem] = blured;
	};

	$scope.isBlured = function(elem) {
		return !!$scope.blured[elem];
	};



	$scope.overitTelefon = function() {
		api.logAnonymousAppAction('REGISTRACE', 'SEND', 'SMS', '');
		Container.setSms($scope.formDataSms);
		$scope.state.sending = true;

		Registrace.sendSms($scope.formDataSms).success(function(response) {

				$scope.state.sending = false;
				$scope.state.sent = true;

			})
			.error(function(response) {
				$scope.state.sending = false;
			});
	};

	$scope.dokoncit = function() {
		Container.setAdvancedInfo($scope.formData);
		$scope.loading = true;

		$scope.formData.company = $scope.step1response.isCompany;

		Registrace.registerStep2($scope.formData, $scope.data.customized).success(function(response) {

			$scope.loading = false;
			$location.path("/ok");
		})

		.error(function(response) {
			$scope.loading = false;
		});
	};

}]);